"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerSPT = void 0;
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
function AnswerSPT(props) {
    var _a;
    const { form, questionNodeId } = props;
    const answer = form.answers[questionNodeId];
    return react_1.default.createElement(Text_1.default, null, (_a = answer === null || answer === void 0 ? void 0 : answer.text) !== null && _a !== void 0 ? _a : answer.value);
}
exports.AnswerSPT = AnswerSPT;
exports.default = AnswerSPT;
